var map = {
	"./gallery_00.jpg": 2009,
	"./gallery_01.jpg": 2010,
	"./gallery_02.jpg": 2011,
	"./gallery_03.jpg": 2012,
	"./gallery_04.jpg": 2013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2008;